import { BreakPoint, ResponsiveConfig } from '@actiris/forms';

// using arrow function will break the build (ng build --prod)
export function isMobile(bp: BreakPoint<string>) {
    return bp.label === 'XS';
}

export const APP_RESPONSIVE_CONFIG: ResponsiveConfig = {
    isMobile,
};
